import styled, { css } from 'styled-components';

export const StyledContent = styled.div``;

export const StyledFooter = styled.footer<{
  reverseFooter: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  ${({ reverseFooter }) => reverseFooter && css`
    flex-direction: row-reverse;
  `}
`;

export const StyledLeftFooter = styled.div`

`;

export const StyledMiddleFooter = styled.div<{ $center: boolean}>`
  ${({ $center }) => !$center && css`
    flex: 1;
  `}
`;

export const StyledRightFooter = styled.div<{ $center: boolean}>`
  ${({ $center }) => $center && css`
    flex: 1;
    justify-content: center;
    display: flex;
  `}
`;
